import { createTheme } from "@mui/material";

export const muiTheme = createTheme({
  components: {
    MuiCssBaseline: {
      styleOverrides: {
        body: {
          backgroundColor: "#f9fafb",
          fontFamily: "Regular",
          lineHeight: 1.5,
          fontSize: "14px",
          minHeight: "100vh",
        },
      },
    },
  },
  colorSchemes: {
    light: {
      palette: {
        main: {
          grey: "#D1D4D9",
          actionBlue: "#006694",
          actionHover: "#004869",
          actionDisabled: "#E6F0F4",
          navy: "#0C314E",
          dark: "#2C3138",
          black: "#000000",
          white: "#FFFFFF",
        },
        background: {
          white: "#FFFFFF",
          offwhite: "#F9F9F9",
          blue1: "#F3FAFF",
          blue2: "#B2EBF2",
          blue3: "#80DEEA",
        },
        primary: {
          50: "#e6f0f4",
          100: "#b0d0de",
          200: "#b0d0de",
          300: "#5498b7",
          400: "#3385a9",
          500: "#006694",
          600: "#005d87",
          700: "#004869",
          800: "#003851",
          900: "#002b3e",
        },
        neutral: {
          25: "#f7f7f7",
          50: "#f0f1f3",
          100: "#d1d4d9",
          200: "#bac0c7",
          300: "#9ba3ae",
          400: "#87919e",
          500: "#697586",
          600: "#606a7a",
          700: "#4b535f",
          800: "#3a404a",
          900: "#2c3138",
        },
        success: {
          50: "#e7f8f0",
          100: "#b6e9d1",
          200: "#92deba",
          300: "#60cf9b",
          400: "#41c588",
          500: "#12b76a",
          600: "#10a760",
          700: "#0d824b",
          800: "#0a653a",
          900: "#084d2d",
        },
        error: {
          50: "#feeceb",
          100: "#fac5c1",
          200: "#f8a9a3",
          300: "#f5827a",
          400: "#f36960",
          500: "#f04438",
          600: "#da3e33",
          700: "#aa3028",
          800: "#84251f",
          900: "#651d18",
        },
        warning: {
          50: "#fef4e6",
          100: "#fdddb3",
          200: "#fbcc8e",
          300: "#fab55a",
          400: "#f9a63a",
          500: "#f79009",
          600: "#e18308",
          700: "#af6606",
          800: "#884f05",
          900: "#683c04",
        },
      },
    },
  },
  typography: {
    allVariants: {
      fontFamily: ["Poppins", "sans-serif"].join(","),
    },
    fontSize: 12,
    // dp_lg
    h1_bold: {
      fontSize: "34px",
      lineHeight: "42px",
      fontWeight: "700",
    },
    // dp_md
    h1_med: {
      fontSize: "34px",
      lineHeight: "42px",
      fontWeight: "500",
    },
    // dp_sm
    h2_bold: {
      fontSize: "24px",
      lineHeight: "42px",
      fontWeight: "700",
    },
    h2_med: {
      fontSize: "24px",
      lineHeight: "42px",
      fontWeight: "500",
    },
    h3_bold: {
      fontSize: "20px",
      lineHeight: "38px",
      fontWeight: "600",
    },
    h3_med: {
      fontSize: "20px",
      lineHeight: "38px",
      fontWeight: "500",
    },
    h3_reg: {
      fontSize: "20px",
      lineHeight: "38px",
      fontWeight: "400",
    },
    h4_bold: {
      fontSize: "16px",
      lineHeight: "24px",
      fontWeight: "700",
    },
    h4_med: {
      fontSize: "16px",
      lineHeight: "24px",
      fontWeight: "500",
    },
    h5_bold: {
      fontSize: "14px",
      lineHeight: "24px",
      fontWeight: "700",
    },
    h5_med: {
      fontSize: "14px",
      lineHeight: "24px",
      fontWeight: "500",
    },
    body_bg_med: {
      fontSize: "16px",
      lineHeight: "24px",
      fontWeight: "500",
    },
    body_bg_reg: {
      fontSize: "16px",
      lineHeight: "24px",
      fontWeight: "400",
    },
    body_md_med: {
      fontSize: "14px",
      lineHeight: "24px",
      fontWeight: "500",
    },
    body_md_reg: {
      fontSize: "14px",
      lineHeight: "24px",
      fontWeight: "400",
    },
    body_sm_med: {
      fontSize: "12px",
      lineHeight: "24px",
      fontWeight: "500",
    },
    body_sm_reg: {
      fontSize: "12px",
      lineHeight: "24px",
      fontWeight: "400",
    },
    captions_bold: {
      fontSize: "10px",
      lineHeight: "16px",
      fontWeight: "700",
    },
    action_button: {
      fontSize: "14px",
      lineHeight: "20px",
      fontWeight: "600",
    },
    captions_med: {
      fontSize: "10px",
      lineHeight: "16px",
      fontWeight: "500",
    },
    captions_reg: {
      fontSize: "10px",
      lineHeight: "16px",
      fontWeight: "400",
    },
  },
  breakpoints: {
    values: {
      mobile: 300,
      tablet: 744,
      desktop: 1280,
    },
  },
});
